import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { COPYRIGHT_START_YEAR } from '../../constants/app.constants';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  copyrightHolder = 'Quorum Health';
  currentYear = new Date().getFullYear();
  copyrightYears = COPYRIGHT_START_YEAR === this.currentYear ? COPYRIGHT_START_YEAR : `${COPYRIGHT_START_YEAR} - ${this.currentYear}`
  version = environment.uiVersion;
}
